import { render, staticRenderFns } from "./LocalLore.vue?vue&type=template&id=cb695fe4&scoped=true"
import script from "./LocalLore.vue?vue&type=script&lang=js"
export * from "./LocalLore.vue?vue&type=script&lang=js"
import style0 from "./LocalLore.vue?vue&type=style&index=0&id=cb695fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb695fe4",
  null
  
)

export default component.exports